import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Help(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm1.032-9.304l-1.54.448a1.823 1.823 0 01-.462-1.246c0-.936.66-1.405 1.234-1.81.438-.311.824-.585.824-1.004 0-.434-.336-.798-1.106-.798-.7 0-1.288.336-1.722.868L9.126 8.88c.742-.882 1.862-1.358 3.066-1.358 1.806 0 2.912.91 2.912 2.212 0 1.162-.756 1.713-1.408 2.189-.495.36-.93.678-.93 1.185 0 .224.112.462.266.588zm.266 2.324c0 .616-.518 1.134-1.134 1.134a1.147 1.147 0 01-1.134-1.134c0-.616.518-1.134 1.134-1.134.616 0 1.134.518 1.134 1.134z",
    clipRule: "evenodd"
  }));
}

export default Help;